module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAALCAYAAACH6Va0AAAAe0lEQVQ4jcXTvQkCUQwA4M+njSi3hY1w/sxg48g3xnMDHUAFdQCbC1iJB5JLlSLkCySZXNctzPHEVF4cSp+0yTDUwLfJ8AW3wHfJeIXA92Pgs36AzbfK7vX4qeNx2QzGV1j8qekgvMjf9x3nwLMvvUZS5B/b6RMf5c3gDUErEgGj4SzFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/header/btn-hide.png
// module id = 801
// module chunks = 0